import { Injectable } from '@angular/core';
import { EnvService } from './env.service';
import { HttpClient } from '@angular/common/http';
import { UserService } from '../core/services/user.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TimerService {
  readonly baseUrl = `${this.env.URL_API_V1}/timer`;

  constructor(
    private env: EnvService,
    private readonly http: HttpClient,
    private userService: UserService
  ) {}

  toHeaderInfo = new Subject<any>();

  createTimer(timer) {
    return this.http.post<any[]>(`${this.baseUrl}/createTimer`, timer);
  }

  findTimerById(id) {
    return this.http.get<any>(`${this.baseUrl}/findTimerById/${id}`);
  }

  findAllTimer() {
    return this.http.get<any[]>(`${this.baseUrl}/findAllTimer`);
  }

  findAllTimerActive() {
    return this.http.get<any[]>(`${this.baseUrl}/findAllTimerActive`);
  }
  updateTimer(id, timer) {
    return this.http.put<any[]>(`${this.baseUrl}/updateTimer/${id}`, {
      timer,
      user: this.userService.currentUser,
    });
  }

  deleteTimer(id) {
    return this.http.put<any[]>(
      `${this.baseUrl}/deleteTimer/${id}`,
      this.userService.currentUser
    );
  }
}
